/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ApolloError, gql, useMutation } from "@apollo/client";

import { useErrorsOrSuccessHandler } from "graphql/errorHandlers";
import { ERROR_FRAGMENT, ErrorFragment } from "graphql/fragments";

const DESTROY_TRANSFER = gql`
  mutation ($id: ID!) {
    destroyTransfer(input: { id: $id }) {
      errors {
        ...ErrorFragment
      }
    }
  }
  ${ERROR_FRAGMENT}
`;

interface Payload {
  errors: ErrorFragment[];
}

interface DestroyTransferMutation {
  destroyTransfer: Payload | null;
}

export const useDestroyTransferMutation = () => {
  const handleErrors = useErrorsOrSuccessHandler();

  const [mutation, { data, loading }] = useMutation<
    DestroyTransferMutation,
    { id: string }
  >(DESTROY_TRANSFER);

  const destroyTransfer = (id: string, onSuccess?: () => void) =>
    mutation({ variables: { id } })
      .then(({ data, errors }) => {
        const dataErrors = data?.destroyTransfer?.errors ?? [];

        handleErrors({ dataErrors, graphqlErrors: errors, onSuccess });
      })
      .catch((_error: ApolloError) => null);

  return {
    destroyTransfer,
    isLoading: loading,
    errors: data?.destroyTransfer?.errors ?? [],
  };
};
